import { render, staticRenderFns } from "./LoginAndRegisterModal.vue?vue&type=template&id=2f3d3456&scoped=true&"
import script from "./LoginAndRegisterModal.vue?vue&type=script&lang=js&"
export * from "./LoginAndRegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./LoginAndRegisterModal.vue?vue&type=style&index=0&id=2f3d3456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d3456",
  null
  
)

export default component.exports